import { Component } from 'react'

import * as h from 'h'

import SwitchFilters from 'components/SwitchFilters'
import { FollowButtons } from 'components/SocialMedia'

import styles from './styles.scss'

export default class Filters extends Component {
  render () {
    const { availableTags, onTagsChange } = this.props

    return availableTags.length === 0
      ? h.h(FollowButtons, h.ca(styles.socialButtons))
      : h.div(h.ca(styles.filters),
          h.h(SwitchFilters, {
            options: availableTags.map(name => ({
              name,
              brand: 'success'
            })),
            onChange: onTagsChange
          }),
          h.h(FollowButtons, h.ca(styles.filterSocialButtons))
        )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/NewsEvents/Filters.js